import {StateCreator} from 'zustand'
import type {IHuddle, IInitiativeOwner} from '../../types'

export interface ITaskHuddleStore {
  // Huddle UI state
  selectHuddle: IHuddle | null
  newHuddle: boolean
  searchValue: string
  clearEditor: boolean

  // Huddle UI actions
  addNewHuddle: (huddle: IHuddle) => void
  removeNewHuddle: (save: boolean) => void
  selectCurrentHuddle: (huddle: IHuddle) => void
  selectHuddlePeople: (people: IInitiativeOwner[]) => void
  selectHuddleText: (text: string) => void
  changeSearchValue: (value: string) => void
  resetHuddles: () => void
}

const initialHuddleState = {
  selectHuddle: null,
  newHuddle: false,
  searchValue: '',
  clearEditor: true,
}

export const createTaskHuddleSlice: StateCreator<
  ITaskHuddleStore,
  [],
  [],
  ITaskHuddleStore
> = set => ({
  ...initialHuddleState,

  addNewHuddle: huddle =>
    set(state => ({
      clearEditor: !state.clearEditor,
      selectHuddle: huddle,
      newHuddle: true,
    })),

  removeNewHuddle: (_save: boolean) =>
    set({newHuddle: false, selectHuddle: null}),

  selectCurrentHuddle: huddle => set({selectHuddle: huddle}),

  selectHuddlePeople: people =>
    set(state => ({
      selectHuddle: state.selectHuddle ? {...state.selectHuddle, people} : null,
    })),

  selectHuddleText: text =>
    set(state => ({
      selectHuddle: state.selectHuddle
        ? {...state.selectHuddle, descriptionHTML: text}
        : null,
    })),

  changeSearchValue: value => set({searchValue: value}),

  resetHuddles: () => set(initialHuddleState),
})
